import React, { useContext } from 'react';
import { Navigate } from 'react-router';
import { ServerResponseContext } from '../../context/ServerResponseContext';

interface Props {
  to: string;
  permanent?: boolean;
}

export const ServerRedirect: React.FC<Props> = ({ to, permanent = true }) => {
  const context = useContext(ServerResponseContext);
  if (context) {
    // eslint-disable-next-line react-hooks/immutability
    context.status = permanent ? 301 : 302;
    // eslint-disable-next-line react-hooks/immutability
    context.redirectTo = to;
  }

  return (
    <Navigate
      replace={ true }
      to={ to } />
  );
};
